<template>
  <el-input v-bind="$attrs" v-on="inputListeners" :class="computedClass">
    <template slot="prepend">
      <slot name="prepend"></slot>
    </template>
    <!-- {{$slots}} -->
  </el-input>
</template>
<script>
export default {
  inheritAttrs: false,
  data: function() {
    return {};
  },
  created() {},
  computed: {
    inputListeners: function() {
      var vm = this;
      // `Object.assign` merges objects together to form a new object
      return Object.assign(
        {},
        // We add all the listeners from the parent
        this.$listeners,
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        {
          // This ensures that the component works with v-model
          input: function(event) {
            vm.$emit("input", event);
          }
        }
      );
    },
    computedClass() {
      if (this.$attrs.inputType === "search") {
        return "er-input input--search";
      }
      return "er-input";
    }
  }
};
</script>
<style lang="scss">
.input--search {
  position: relative;
  padding-right: 4px;
  width: $search-input-size;
  // input {
  //   background: #f2f3f4;
  //   border-radius: 8px;
  //   border: 0px solid #dcdfe6;
  //   color: black !important;
  //   width: 100%;
  // }
  // i {
  //   width: 16px;
  //   font-weight: 700;
  //   margin-right: 10px;
  // }
}
</style>
